<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.74062 15.6C10.3438 13.5938 14 8.73125 14 6C14 2.6875 11.3125 0 8 0C4.6875 0 2 2.6875 2 6C2 8.73125 5.65625 13.5938 7.25938 15.6C7.64375 16.0781 8.35625 16.0781 8.74062 15.6ZM8 4C8.53043 4 9.03914 4.21071 9.41421 4.58579C9.78929 4.96086 10 5.46957 10 6C10 6.53043 9.78929 7.03914 9.41421 7.41421C9.03914 7.78929 8.53043 8 8 8C7.46957 8 6.96086 7.78929 6.58579 7.41421C6.21071 7.03914 6 6.53043 6 6C6 5.46957 6.21071 4.96086 6.58579 4.58579C6.96086 4.21071 7.46957 4 8 4Z" fill="#71767D"/>
    </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#71767D',
    },
    size: {
      type: Number,
      default: 17,
    },
  },
};
</script>